import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ConfigService } from 'app/core/services/config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { DynamicOnboardingService } from 'app/core/components/dynamic-onboarding/dynamic-onboarding.service';
import { RxComponent } from 'app/core/components/common/rx.component';
// import { OnboardingService } from 'app/core/components/onboarding/onboarding.service';

@Component({
  selector: 'itpx-logo-card',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.css']
})
export class LogoCardComponent extends RxComponent {

  // @Input() private account: Observable<string>; 
  @Input() private message: string = '';
  @Input() private dimensions = {width: 500, height: 500, comp: 'min'};
  @Output() private uploadedImage = new EventEmitter<any>();
  // private cancelRoute: string = '/agora/account-data/accounts';
  private component: string = 'content-uploader'; //'agoraprint';
  // private saveRoute: string = '/agora/account-data/accounts';
  private imgSrc: string;
  // private details: any;
  private id: string;
  private name: string = 'print';
  // private sub: Subscription;
  private defaultImage: string;
  private type: Array<any> = ['png', 'jpeg'];
  private showPreviewImg: boolean = false;
  private showProgress: boolean = false;
  private bucket: string = this.configService.get('aws').uploadsBucket;

  constructor(
    private service: DynamicOnboardingService,
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
    this.defaultImage = this.configService.get('images').defaultImage;
  }

  ngOnInit() {
    // this.sub = this.route.params.subscribe(params => {
            // this.id = params['id'];
            this.service.getAccountDomain().bindToLifecycle(this)
            // this.account
            .subscribe( body => {
            // this.service.getAccountDetails(id)
                // .subscribe(
                      // body => {
                        // this.details = <any>body['data'];
                        if(body.printLogo == null || body.printLogo.length == 0) {
                            this.imgSrc = '';
                        } else  {
                            this.imgSrc = body.printLogo;
                        }
                    }
                );
    // });
  }

  uploadComplete(event: any) {
    // console.log(event);
    this.uploadedImage.emit(event.data.path);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/components/dynamic-onboarding/logo/logo.component.ts